import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconOffline(props: SvgIconProps) {
  return (
    <SVGIcon width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#a)">
        <path stroke="currentColor" d="m2 11 9-9" />
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="M3.637 3.182A2.501 2.501 0 0 1 8.501 4v.5H9c.062 0 .123.003.184.008l.832-.831a2.98 2.98 0 0 0-.547-.14 3.5 3.5 0 0 0-6.664-.968A3.501 3.501 0 0 0 3.5 9.5H4.194l1-1H3.501a2.5 2.5 0 0 1-.28-4.984l.313-.035.103-.299ZM6.607 8.5l-1 1h3.394a3 3 0 0 0 1.915-5.309l-.711.712A2 2 0 0 1 9 8.5H6.608Z"
          clipRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="currentColor" d="M0 0h12v12H0z" />
        </clipPath>
      </defs>
    </SVGIcon>
  );
}
